(() => {
  const gate = document.getElementById('dut-country-gate');
  if (!gate || window.Shopify?.designMode || window.Shopify?.inspectMode || window.Shopify?.previewMode || new URLSearchParams(location.search).has('preview_theme_id')) return;
  const crawler = /Googlebot|Google-InspectionTool|AdsBot-Google|Storebot-Google|Mediapartners-Google|bingbot|BingPreview|DuckDuckBot|Slurp|Applebot|facebookexternalhit|Facebot|Twitterbot|LinkedInBot|Pinterestbot|WhatsApp|Slackbot/i;
  if (crawler.test(navigator.userAgent)) return;
  const extras = (gate.dataset.extraCountries || '').toUpperCase().split(/[\s,;]+/).filter(code => /^[A-Z]{2}$/.test(code));
  const allowed = new Set(['AU', 'NZ', ...extras]);
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 4000);
  const root = window.Shopify?.routes?.root || '/';
  fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`, {
    credentials: 'same-origin', cache: 'no-store', signal: controller.signal
  }).then(response => {
    if (!response.ok) throw new Error('Location unavailable');
    return response.json();
  }).then(data => {
    const value = data?.detected_values?.country?.handle;
    const country = typeof value === 'string' ? value.toUpperCase() : '';
    if (!/^[A-Z]{2}$/.test(country) || allowed.has(country) || ['XX', 'ZZ', 'T1'].includes(country)) return;
    if (typeof gate.showModal !== 'function') return;
    gate.addEventListener('cancel', event => event.preventDefault());
    document.documentElement.classList.add('dut-country-restricted');
    gate.showModal();
    gate.querySelector('h1').focus({ preventScroll: true });
  }).catch(() => {}).finally(() => clearTimeout(timeout));
})();
